/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum CustomErrorCode {
  EMPLOYEE_ASSIGNMENT_EXCEPTION = 'employee_assignment_exception',
}
